// Text Video Slider Initialization
console.log('TextVideoSlider script loaded');

// Simple slider functionality without complex Swiper detection
function initTextVideoSliders() {
  const sections = document.querySelectorAll('[data-wetheme-section-type="text-video-slider"]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.wethemeSectionId;
    console.log('Initializing sliders for section:', sectionId);
    
    // Initialize mobile slider
    initMobileSlider(section);
    
    // Initialize desktop slider
    initDesktopSlider(section);
  });
}

function initMobileSlider(section) {
  const mobileSlider = section.querySelector('.text-video-slider__swiper');
  const prevBtn = section.querySelector('.text-video-slider__nav-prev');
  const nextBtn = section.querySelector('.text-video-slider__nav-next');
  
  if (!mobileSlider) return;
  
  console.log('Mobile slider found, slides:', mobileSlider.querySelectorAll('.swiper-slide').length);
  
  // Check for infinite slider setting
  const infiniteSlider = section.dataset.infiniteSlider === 'true';
  console.log('Mobile infinite slider setting:', infiniteSlider);
  
  // Simple manual slider functionality
  let currentSlide = 0;
  const slides = mobileSlider.querySelectorAll('.swiper-slide');
  const totalSlides = slides.length;
  
  if (totalSlides <= 1) return;
  
  // Hide all slides except first
  slides.forEach((slide, index) => {
    slide.style.display = index === 0 ? 'block' : 'none';
    console.log(`Mobile slide ${index} display set to: ${index === 0 ? 'block' : 'none'}`);
  });
  
  // Navigation functions
  function showSlide(index) {
    console.log(`Showing mobile slide ${index}`);
    slides.forEach((slide, i) => {
      const display = i === index ? 'block' : 'none';
      slide.style.display = display;
      console.log(`Mobile slide ${i} display set to: ${display}`);
    });
    currentSlide = index;
  }
  
  function nextSlide() {
    let next;
    if (infiniteSlider) {
      // Infinite loop: always wrap around
      next = (currentSlide + 1) % totalSlides;
    } else {
      // Finite: stop at the end
      next = Math.min(currentSlide + 1, totalSlides - 1);
    }
    console.log(`Mobile next: ${currentSlide} -> ${next}`);
    showSlide(next);
  }
  
  function prevSlide() {
    let prev;
    if (infiniteSlider) {
      // Infinite loop: always wrap around
      prev = (currentSlide - 1 + totalSlides) % totalSlides;
    } else {
      // Finite: stop at the beginning
      prev = Math.max(currentSlide - 1, 0);
    }
    console.log(`Mobile prev: ${currentSlide} -> ${prev}`);
    showSlide(prev);
  }
  
  // Add event listeners
  if (nextBtn) {
    console.log('Adding mobile next button listener');
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Mobile next button clicked');
      nextSlide();
    });
  }
  
  if (prevBtn) {
    console.log('Adding mobile prev button listener');
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Mobile prev button clicked');
      prevSlide();
    });
  }
}

function initDesktopSlider(section) {
  const desktopSlider = section.querySelector('.text-video-slider__desktop-swiper');
  const prevBtn = section.querySelector('.text-video-slider__desktop-nav-prev');
  const nextBtn = section.querySelector('.text-video-slider__desktop-nav-next');
  
  if (!desktopSlider) return;
  
  console.log('Desktop slider found, slides:', desktopSlider.querySelectorAll('.swiper-slide').length);
  
  // Check for infinite slider setting
  const infiniteSlider = section.dataset.infiniteSlider === 'true';
  console.log('Desktop infinite slider setting:', infiniteSlider);
  
  // Desktop slider shows 2 slides at once, moves 1 slide at a time
  let currentStartIndex = 0;
  const slides = desktopSlider.querySelectorAll('.swiper-slide');
  const totalSlides = slides.length;
  
  if (totalSlides <= 2) return;
  
  // Show first 2 slides, hide the rest
  slides.forEach((slide, index) => {
    slide.style.display = index < 2 ? 'block' : 'none';
    console.log(`Desktop slide ${index} display set to: ${index < 2 ? 'block' : 'none'}`);
  });
  
  // Navigation functions for desktop (moves 1 slide at a time, shows 2 slides)
  function showSlides(startIndex) {
    console.log(`Showing desktop slides starting from ${startIndex}`);
    const endIndex = Math.min(startIndex + 1, totalSlides - 1);
    
    slides.forEach((slide, i) => {
      const display = (i >= startIndex && i <= endIndex) ? 'block' : 'none';
      slide.style.display = display;
      console.log(`Desktop slide ${i} display set to: ${display}`);
    });
    currentStartIndex = startIndex;
  }
  
  function nextSlide() {
    let next;
    if (infiniteSlider) {
      // Infinite loop: wrap around to beginning
      const maxStartIndex = totalSlides - 2;
      next = (currentStartIndex + 1) % (maxStartIndex + 1);
    } else {
      // Finite: stop at the end
      const maxStartIndex = totalSlides - 2; // Can't start beyond this to show 2 slides
      next = Math.min(currentStartIndex + 1, maxStartIndex);
    }
    console.log(`Desktop next: ${currentStartIndex} -> ${next}`);
    showSlides(next);
  }
  
  function prevSlide() {
    let prev;
    if (infiniteSlider) {
      // Infinite loop: wrap around to end
      const maxStartIndex = totalSlides - 2;
      prev = (currentStartIndex - 1 + maxStartIndex + 1) % (maxStartIndex + 1);
    } else {
      // Finite: stop at the beginning
      prev = Math.max(currentStartIndex - 1, 0);
    }
    console.log(`Desktop prev: ${currentStartIndex} -> ${prev}`);
    showSlides(prev);
  }
  
  // Add event listeners
  if (nextBtn) {
    console.log('Adding desktop next button listener');
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Desktop next button clicked');
      nextSlide();
    });
  }
  
  if (prevBtn) {
    console.log('Adding desktop prev button listener');
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Desktop prev button clicked');
      prevSlide();
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTextVideoSliders);
} else {
  initTextVideoSliders();
}

// Also try after a delay to catch any late-loading content
setTimeout(initTextVideoSliders, 1000);
